//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// PageFooter - Standard Page Footer - Version 1.006 - May 29, 2019
//----------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import React, { } from 'react';
import { Link } from 'react-router-dom'
import { SessionInfo } from './App';

class PageFooter extends React.Component { 
  state = {   
    appDisplay: false, 
  };           
  componentDidMount() { 
    if (this.props.IsApp || SessionInfo.IsApp === true)
      this.setState({ appDisplay: true });
  }
  render() {
    return (
      <div id="footerCntr">
        <div id="footTopStrip"></div> {/* Blue Line */}
        <div className="footermenu">
          {/*<ul>
            <li><Link to="/AppMain" className="select">{this.props.L1}</Link></li>
            {this.state.appDisplay && <div>
              <li><Link to="/ProjectDirectory">Projects</Link></li>
              <li><Link to="/ProjectDetail">Detail</Link></li>
              <li><Link to="/ProjectContract">Contract</Link></li>
              <li><Link to="/ParticipantProfile">Profile</Link></li>
              <li><Link to="/WorkflowDefinition">Workflow</Link></li> 
            </div>}                                                             
          </ul>
          <br/>*/}
          <p>&nbsp;&nbsp;Contract Flow - Version: {SessionInfo.appVersion}-{SessionInfo.Platform}-Alpha - &copy; Copyright <a href="https://Omecron.com/" target="_blank" rel="noopener noreferrer"> Omecron Inc. 2019-2020</a>  All Rights Reserved</p> 
        </div>
        <div id="footerRight">  
          <div className="twitterbox">
            <a href="https://www.facebook.com/OmecronGlobal/" target="_blank" rel="noopener noreferrer"><img src={require("./images/sub/facebook.png")} alt="" className="loginImage" width="20px"/></a>
            <a href="https://www.linkedin.com/company/Omecron/?trk=company_logo" target="_blank" rel="noopener noreferrer"> <img src={require("./images/sub/linkedin.png")} alt="" className="loginImage" /></a>
            <a href="https://twitter.com/Omecron_Global" target="_blank" rel="noopener noreferrer"> <img src={require("./images/sub/twitter.png")} alt="" className="loginImage" /></a>
          </div>
          <div className="linkbox">                                                                                       
            <Link to="/AppMain"><img src={require("./images/Home2.png")} alt="" className="loginImage" /></Link>
            <Link to="/AboutPage"><img src={require("./images/Info2.png")} alt="" className="loginImage" /></Link>
            <Link to="/SettingsPage"><img src={require("./images/Gear.png")} alt="" className="loginImage" /></Link>
            <Link to="/ContactUs"><img src={require("./images/WriteMessage.png")} alt="" className="loginImage" /></Link>
          </div>
        </div>
      </div>
    )
  }
}
      
export default PageFooter;